import { useState } from "react";
import { Dialog } from "primereact/dialog";
import Textarea from "../../../componentes/input/textarea";
import Button from "../../../componentes/button/button";
import { processoInfo } from "../../../utils/solicitacoes/processoRegistry";

// Confirmação forte de eliminação administrativa (soft delete) — exige motivo e que o admin
// digite o número da solicitação, para evitar exclusões acidentais. Mesma estrutura de
// CancelarSolicitacaoModal.jsx, com o passo extra de confirmação por número.
export default function EliminarSolicitacaoModal({ visible, solicitacao, onFechar, onConfirmar }) {
    const [motivo, setMotivo] = useState("");
    const [numeroConfirmacao, setNumeroConfirmacao] = useState("");
    const [enviando, setEnviando] = useState(false);

    function fechar() {
        if (enviando) return;
        setMotivo("");
        setNumeroConfirmacao("");
        onFechar();
    }

    function confirmar() {
        if (!motivo.trim() || numeroConfirmacao.trim() !== solicitacao.numero) return;
        setEnviando(true);
        onConfirmar(motivo.trim())
            .then(() => { setMotivo(""); setNumeroConfirmacao(""); })
            .catch(() => {})
            .finally(() => setEnviando(false));
    }

    if (!solicitacao) return null;

    const processoLabel = processoInfo(solicitacao.tipoProcesso)?.label || solicitacao.tipoProcesso;
    const numeroConfere = numeroConfirmacao.trim() === solicitacao.numero;

    return (
        <Dialog
            header="Eliminar Solicitação"
            visible={visible}
            onHide={fechar}
            blockScroll
            className="w-[95%] max-w-lg"
            footer={
                <div className="flex justify-end gap-3">
                    <Button variant="outline" label="Cancelar" onClick={fechar} disabled={enviando} />
                    <Button
                        variant="red"
                        label="Eliminar definitivamente"
                        iconLeft="fa fa-trash"
                        loading={enviando}
                        disabled={!motivo.trim() || !numeroConfere}
                        onClick={confirmar}
                    />
                </div>
            }
        >
            <div className="p-4 flex flex-col gap-4">
                <p className="text-sm text-foreground">Você está prestes a eliminar:</p>

                <div className="grid grid-cols-2 gap-3 text-sm rounded-lg bg-muted px-4 py-3">
                    <div>
                        <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Solicitação</span>
                        <span className="block text-foreground font-medium">{solicitacao.numero}</span>
                    </div>
                    <div>
                        <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Processo</span>
                        <span className="block text-foreground font-medium">{processoLabel}</span>
                    </div>
                    <div className="col-span-2">
                        <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Solicitante</span>
                        <span className="block text-foreground font-medium">{solicitacao.solicitanteNome}</span>
                    </div>
                </div>

                <p className="text-xs text-destructive">
                    <i className="fa fa-exclamation-triangle mr-1" />
                    Essa operação é administrativa e removerá a solicitação das listagens normais do sistema.
                </p>

                <Textarea
                    id="motivo-eliminacao"
                    label="Motivo da eliminação"
                    required
                    placeholder="Informe o motivo..."
                    value={motivo}
                    onChange={e => setMotivo(e.target.value)}
                    rows={3}
                />

                <div className="flex flex-col gap-1.5">
                    <label className="text-sm font-medium text-foreground/80">
                        Digite o número da solicitação (<span className="font-semibold">{solicitacao.numero}</span>) para confirmar <span className="text-destructive">*</span>
                    </label>
                    <input
                        type="text"
                        value={numeroConfirmacao}
                        onChange={e => setNumeroConfirmacao(e.target.value)}
                        placeholder={solicitacao.numero}
                        className={`w-full h-9 px-3 text-sm border rounded-lg bg-card outline-none focus:ring-2 focus:ring-primary/15 ${
                            numeroConfirmacao && !numeroConfere ? "border-destructive" : "border-input focus:border-primary"
                        }`}
                    />
                </div>
            </div>
        </Dialog>
    );
}
